<template>
    <div class="fileWrap">
        <a href="javascript:void(0);" class="input-wrap">
            <el-button type="primary">上传文件</el-button>
            <input type="file"  @change="fileChange2" ref="upload" multiple>
        </a>
        <div class="file-content">
            <p v-for="( item,i ) in data" :key="i">
                <a :href="item.url">{{ item.name }}</a>
                <i class="iconfont icon-shanchu"　@click="delTab(item,i)"></i>
                <span>上传时间:&emsp;{{item.uploadTime?item.uploadTime:'无'}}</span>
            </p>
        </div>
        <div class="file-content-loading">
            <p v-for="(item,i) in loadingList" :key="i">
                <span>{{item.name}}</span>
                <el-progress type="circle" :percentage="item.progress?item.progress:0" :status="loadStatus" :width="loadWidth" class="progress"></el-progress>
            </p>
        </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import Config from "../../app.config";
    const BASE_API = Config.BASE_API;
    const Axios=require('axios')
    export default {
        props:{
            data:Array,
            getFiles:Function
        },
        data() {
            return {
                loadingList:[],     //正在上传中的文件列表
                loadProgress:0,    //上传进度
                loadStatus:null,     //上传状态
                loadWidth:30,     //环形进度条宽度
            }
        },
        created() {

        },
        methods: {
            fileChange(e){
                let files = e.target.files || e.dataTransfer.files;
                console.log(files[0]);
                console.log(this.$refs.upload.files[0]);
                let size=files[0].size/1024
                size=size/1024
                // console.log(size);
                // console.log(files);
                // console.log(files[0].size);
                if (!files.length){
                    this.$message.error('上传文件大小不能为空，请重新选择');
                    return;
                };
                if (size>100){
                    this.$message.error('上传文件大小不能超过100MB')
                } else{
                    let params = { file_name:files[0] };
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    commonService.uploading(params).then(res => {
                        console.log('上传');
                        console.log(res);
                        loading.close();
                        this.data.push({
                            name:res.file_name,
                            url:res.download_url,
                            uploadTime:res.upload_time
                        })
                        console.log(this.data);
                        this.getFiles(this.data);
                    }).catch( err => {
                        loading.close();
                        this.$message.error('上传失败，请检查网络连接或重试');
                    })
                }
            },
            delTab(item,i){
                this.data.splice(i,1);
                this.getFiles(this.data);
            },
            fileChange2(e){
                let files=this.$refs.upload.files
                console.log(files);
                // for (let key in files) {
                //         console.log(files[key]);
                //         console.log(files[key].size);
                //         if (!files[key].size){
                //             this.$message.error('上传文件中存在空文件，请重新选择')
                //             return
                //         }
                // }
                //File
                let length=files.length
                let filesArr=[]    //存放FileList对象中的每个文件信息
                let nullFile=[]    //存放空文件的名称
                let exceedFile=[]   //存放超出100M的文件名称
                 for (let i=0;i<length;i++){
                    filesArr.push(files[i])
                    if (!files[i].size){
                        nullFile.push(files[i].name)
                    }else{
                        if (((files[i].size/1024)/1024)<100) {
                            this.loadingList.push({name:files[i].name,progress:0})
                            this.upload(files[i])
                        }else{
                            exceedFile.push(files[i].name)
                        }
                    }
                }
                //判断是否存在空文件，提示重新选择
                if (nullFile.length){
                    let nullFileNames=nullFile.join(', ||  ')
                    this.$message({
                        type:'warning',
                        message:`${nullFileNames} 为空文件，请重新选择`,
                        duration:'5000',
                        offset:20
                    })
                }
                //判断是否存在超出100M的文件，提示重新选择
                if (exceedFile.length){
                    let exceedFileNames=exceedFile.join(', ||  ')
                    this.$message({
                        type:'warning',
                        message:`${exceedFileNames} 文件过大，请选择小于100MB的文件`,
                        duration:'5000',
                        offset:60
                    })
                }
            },
            upload(file){
                let that=this
                let fd=new FormData()
                // let file=this.$refs.upload.files[0]
                console.log(file);
                fd.append('file_name',file)
                Axios({
                    method:'post',
                    url:`${BASE_API}/fastdfs/v1/upload`,
                    data:fd,
                    headers:{'Content-Type':'multipart/form-data'},
                    onUploadProgress(e){
                        if (e.lengthComputable){
                            // console.log(e);
                            let progress=Number((e.loaded/e.total*100).toFixed(0))
                            that.loadingList[0].progress=progress==100?99:progress
                            // that.loadingList[0].progress=Number((e.loaded/e.total*100).toFixed(0))
                        }
                    }
                }).then(res=>{
                    console.log('成功');
                    // loading.close();
                    let name=res.data.data.file_name
                    this.data.push({
                        name,
                        url:res.data.data.download_url,
                        uploadTime:res.data.data.upload_time
                    })
                    // this.loadingList.shift()
                    let ind=this.loadingList.findIndex(item=> item.name==name)
                    this.loadingList.splice(ind,1)
                    this.getFiles(this.data);
                }).catch( err => {
                    // loading.close();
                    this.$message.error('上传失败，请检查网络连接或重试');
                })
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

    .fileWrap{
        position: relative;
        width:100%;
        input{
            display: inline-block;
            width:100%;
            height: 100%;
            position: absolute;
            opacity: 0;
            filter:alpha(opacity=0);
            left:0;
            top:0;
        }
        .input-wrap {
            text-decoration:none;
            width:100px;
            height:30px;
            line-height:30px;
            display:inline-block;
            overflow:hidden;
            position:relative;
            text-align: center;
            top:0;
            cursor: pointer;
            .el-button{
                display:inline-block;
                width:100%;
                height:100%;
                cursor: pointer;
                text-align: center;
            }
        }

    }
    .file-content{
        p{
            width:300px;
            position: relative;
           a{
               color:rgb(24,144,255)
           }
            span{
                position: absolute;
                left: 323px;
                width: 300px;
                line-height: 24px;
            }
        }
        i{
            float: right;
            cursor: pointer;
            color: #F37258;
        }
    }
    .file-content-loading{
        p{
            width:300px;
            position: relative;
            a{
                color:rgb(24,144,255)
            }
            span{
                display: inline-block;
                width: 270px;
                line-height: 24px;
            }
            .progress{
                vertical-align: middle;
            }
        }
        i{
            float: right;
            cursor: pointer;
            color: #F37258;
        }
    }
</style>
